import type { InventoryListItem } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import { HoverableFlyoutMenu } from "src/components"
import type { ActionItemKey } from "src/hooks"
import { useActionMenu } from "src/hooks"

interface InventoryListRowActionMenuContainerProps {
	item: InventoryListItem
	onActionMenuItemClick: (itemKey: ActionItemKey) => void
	onEELClick: (vehicleKey: string) => Promise<void>
	onMonroneyLabelClick: (vehicleKey: string) => Promise<void>
}

export const InventoryListRowActionMenuContainer = (props: InventoryListRowActionMenuContainerProps) => {
	const { item, onActionMenuItemClick, onEELClick, onMonroneyLabelClick } = props

	const handleEELClick = useCallback(() => onEELClick(item.id), [onEELClick, item.id])
	const handleMonroneyLabelClick = useCallback(() => onMonroneyLabelClick(item.id), [onMonroneyLabelClick, item.id])

	const actionMenu = useActionMenu({
		actionMenu: item.actionMenu,
		onEELClick: handleEELClick,
		onItemClick: onActionMenuItemClick,
		onMonroneyLabelClick: handleMonroneyLabelClick,
		vehicleKey: item.id,
	})

	return <HoverableFlyoutMenu menu={actionMenu} />
}
